import { ChangeDetectionStrategy, Component, Input, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardFaqItem } from '../../../core/services/dashboard.service';
import { TranslatePipe } from '../../../shared/pipes/translate.pipe';

@Component({
  selector: 'app-faq',
  standalone: true,
  imports: [CommonModule, TranslatePipe],
  templateUrl: './faq.component.html',
  styleUrl: './faq.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FaqComponent {
  @Input({ required: true }) items!: DashboardFaqItem[];

  readonly openIds = signal<Set<string>>(new Set<string>());

  toggle(id: string): void {
    const next = new Set(this.openIds());
    if (next.has(id)) {
      next.delete(id);
    } else {
      next.add(id);
    }
    this.openIds.set(next);
  }

  isOpen(id: string): boolean {
    return this.openIds().has(id);
  }
}
